var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_13657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.5H1.5C0.947713 2.5 0.5 2.94771 0.5 3.5V14.5C0.5 15.0523 0.947713 15.5 1.5 15.5H14.5C15.0523 15.5 15.5 15.0523 15.5 14.5V3.5C15.5 2.94771 15.0523 2.5 14.5 2.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.5H15.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4V0.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4V0.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38208 9.77441C6.24401 9.77441 6.13208 9.66248 6.13208 9.52441C6.13208 9.38635 6.24401 9.27441 6.38208 9.27441",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38208 9.77441C6.52015 9.77441 6.63208 9.66248 6.63208 9.52441C6.63208 9.38635 6.52015 9.27441 6.38208 9.27441",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61792 9.77441C9.47985 9.77441 9.36792 9.66248 9.36792 9.52441C9.36792 9.38635 9.47985 9.27441 9.61792 9.27441",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61792 9.77441C9.75599 9.77441 9.86792 9.66248 9.86792 9.52441C9.86792 9.38635 9.75599 9.27441 9.61792 9.27441",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.854 9.77441C12.7159 9.77441 12.604 9.66248 12.604 9.52441C12.604 9.38635 12.7159 9.27441 12.854 9.27441",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.854 9.77441C12.9921 9.77441 13.104 9.66248 13.104 9.52441C13.104 9.38635 12.9921 9.27441 12.854 9.27441",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.146 12.7744C3.00793 12.7744 2.896 12.6625 2.896 12.5244C2.896 12.3863 3.00793 12.2744 3.146 12.2744",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.146 12.7744C3.28407 12.7744 3.396 12.6625 3.396 12.5244C3.396 12.3863 3.28407 12.2744 3.146 12.2744",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38208 12.7744C6.24401 12.7744 6.13208 12.6625 6.13208 12.5244C6.13208 12.3863 6.24401 12.2744 6.38208 12.2744",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38208 12.7744C6.52015 12.7744 6.63208 12.6625 6.63208 12.5244C6.63208 12.3863 6.52015 12.2744 6.38208 12.2744",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61792 12.7744C9.47985 12.7744 9.36792 12.6625 9.36792 12.5244C9.36792 12.3863 9.47985 12.2744 9.61792 12.2744",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61792 12.7744C9.75599 12.7744 9.86792 12.6625 9.86792 12.5244C9.86792 12.3863 9.75599 12.2744 9.61792 12.2744",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_13657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarFigma);
export default __webpack_public_path__ + "static/media/calendar-figma.d7e9eed8942692e571889f0aa4126aba.svg";
export { ForwardRef as ReactComponent };